import Turbolinks from "turbolinks";
import { Modal } from "bootstrap";

import { extractCSRFToken } from "./util/csrf";
import { detectTimeZone } from "./time_zone";

const AGE_CHECKED_COOKIE = 'age_checked';

const isAgeChecked = () =>
  document.cookie.split('; ').some((cookie) => cookie.startsWith(`${AGE_CHECKED_COOKIE}=`));

// 「表示する」= サーバへのPOST。ブラウザ検出のタイムゾーンを同梱し、
// 年齢確認済みcookieとタイムゾーンcookieを1回のレスポンスで揃えてから、ページを1回だけ描き直す。
// 再描画をここに集約することで、タイムゾーン登録の完了タイミングとモーダル表示が競合しなくなる
export function setAgeCheckModal() {
  const toggle = document.getElementById('toggleAgeCheckModalBtn');
  const form = document.getElementById('ageCheckForm');
  if (toggle == null || !(form instanceof HTMLFormElement)) {
    return;
  }

  // Turbolinksのキャッシュ復元でモーダルDOMが残っていても、確認済みなら開かない
  if (isAgeChecked()) {
    return;
  }

  const input = form.elements.namedItem('time_zone');
  if (input instanceof HTMLInputElement) {
    input.value = detectTimeZone();
  }

  form.addEventListener('submit', (event) => {
    event.preventDefault();
    submitAgeCheck(form);
  });

  toggle.click();
}

const submitAgeCheck = (form: HTMLFormElement) => {
  fetch(form.action, {
    method: 'POST',
    body: new FormData(form),
    headers: {
      'Accept': 'application/json',
      'X-CSRF-Token': extractCSRFToken(),
    },
  }).then((response) => {
    if (!response.ok) {
      // cookieがブロックされている等で保存できなかった。次のページでまた聞くだけなので今回は閉じるに留める
      closeModal();
      return;
    }

    // このページは年齢確認前・タイムゾーン未登録の状態で描画済みなので、両cookieが揃った状態で描き直す。
    // モーダル入りのスナップショットが残らないようキャッシュも捨てる
    Turbolinks.clearCache();
    Turbolinks.visit(window.location.href, { action: 'replace' });
  }).catch(() => {
    closeModal();
  });
};

const closeModal = () => {
  const modal = document.getElementById('ageCheckModal');
  if (modal == null) {
    return;
  }

  Modal.getOrCreateInstance(modal).hide();
};
